export default __webpack_public_path__ + "static/media/oled@2x.5f3e6174.png";